import {
  Component, OnInit, Input, ElementRef,
  ChangeDetectionStrategy
} from '@angular/core';
import {TileGroupComponent} from '../tile-group/tile-group.component';
import {MatDialog} from '@angular/material/dialog';
import {YesNoDialogComponent} from '../../yesno-dialog/yesno-dialog.component';

@Component({
    selector: 'mbnm-builder-tile',
    templateUrl: './tile.component.html',
    styleUrls: ['./tile.component.scss'],
    host: {
        '(click)': 'tileClicked($event)',
        '[class.selected]': 'selected',
        '[class.collapsible]': 'collapsible',
        '[class.left-align]': 'leftAlign',
        '[class.secondary]': 'secondary',
        '[class.disabled]': 'disabled'
    },
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TileComponent implements OnInit {
  @Input()
  title: string;

  @Input()
  helpInfo: any;

  @Input()
  choices:any;

  @Input()
  collapsible:boolean = true;

  @Input()
  secondary:boolean = false;

  @Input()
  leftAlign:boolean = false;

  @Input()
  disabled:boolean = false;

  @Input()
  openIcon:string = 'plus';

  public get selected():boolean { return this._parent ? this._parent.selectedTile === this : false};

  public _visited:boolean = false;
  public get visited():boolean{ return this._visited};
  public set visited(val:boolean) { this._visited = val;};

  private _parent:TileGroupComponent;
  public get parent():TileGroupComponent { return this._parent};
  public set parent(val:TileGroupComponent) { this._parent = val;};

  tileClicked($event) {
    if (this.parent && !this.disabled) {
      if (this.collapsible && this.parent.selectedTile === this) {
        this.parent.selectedTile = null;
      } else {
        this.parent.selectedTile = this;
        this._visited = true;
      }
    }
    $event.stopPropagation();
  }

  infoClicked($event) {
    let dialogRef = this.dialog.open(YesNoDialogComponent, {});
    let instance = dialogRef.componentInstance;
    instance.data = {
      closeMethod: this.helpInfo.closeMethod ? this.helpInfo.closeMethod : "x",
      title: this.helpInfo.title,
      message: this.helpInfo.message,
      yesButtonText: this.helpInfo.yesButtonText,
      noButtonText: this.helpInfo.noButtonText
    };
    if ((this.helpInfo.yesButtonText && this.helpInfo.yesClickedCallback) || (this.helpInfo.noButtonText && this.helpInfo.noClickedCallback)) {
      dialogRef.afterClosed().subscribe((result) => {
        if (result && this.helpInfo.yesClickedCallback && this.helpInfo.yesClickedCallbackContext) {
          this.helpInfo.yesClickedCallback.call(this.helpInfo.yesClickedCallbackContext);
        } else if (!result && this.helpInfo.noClickedCallback && this.helpInfo.noClickedCallbackContext) {
          this.helpInfo.noClickedCallback.call(this.helpInfo.noClickedCallbackContext);
        }
      });
    }
    $event.stopPropagation();
  }

  constructor(public elementRef:ElementRef, public dialog:MatDialog) {
  }

  ngOnInit() {
  }
}
